import MainLayouts from "layouts/MainLayouts";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStatusDomain, backorderStatus } from "features/domain/domainsSlice";
import Spinner from "react-bootstrap/Spinner";
import { addDomainToCart } from "features/common/layouts/cartSlice";
import { useQuery } from "helpers/utils";
import {
  notifyWarning,
  notifyError,
  notifySuccess,
} from "components/ToastMessage";
import { Card, Form, Alert } from 'react-bootstrap';

const DomainBackorder = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const result = useSelector((state) => state.domain);
  const backorder = useSelector((state) => state.cart.productsList);
  const [domain, setDomain] = useState("");

  const handlerSendToCart = (e) => {
    if (domain) {
      const splitDomain = domain.split(".");
      if (!domain || splitDomain[0] === undefined || splitDomain[0] === "") {
        notifyWarning("Domain Backorder Anda Kosong!");
        return;
      }

      if (
        !splitDomain[1] ||
        splitDomain[1] === undefined ||
        splitDomain[1] === ""
      ) {
        notifyWarning("Ekstensi Domain Backorder Anda Kosong!");
        return;
      }

      e.preventDefault();
      dispatch(getStatusDomain(domain));
    }
  };

  useEffect(() => {
    if (query.domainbackorder) {
      const splitDomain = query.domainbackorder.split(".");
      if (
        !query.domainbackorder ||
        splitDomain[0] === undefined ||
        splitDomain[0] === ""
      ) {
        notifyWarning("Domain Backorder Anda Kosong!");
        return;
      }

      if (
        !splitDomain[1] ||
        splitDomain[1] === undefined ||
        splitDomain[1] === ""
      ) {
        notifyWarning("Ekstensi Domain Backorder Anda Kosong!");
        return;
      }
      dispatch(getStatusDomain(query.domainbackorder));
    }
  }, [query.domainbackorder, dispatch]);

  useEffect(() => {
    if (result) {
      if (result.backorder_status === false) {
        notifyError(
          "Domain tersebut belum terdaftar sebagai domain backorder!"
        );
      } else if (result.backorder_status === true) {
        const { domain, status, duration, priceRenew } = result.domain_register;
        dispatch(
          addDomainToCart({
            name: domain,
            price: "150000",
            type: "backorder",
            domain: "backorder",
            pid: 382,
            customfields: [{ id: 1215, value: domain }],
          })
        );
        dispatch(
          addDomainToCart({
            name: domain,
            price: priceRenew,
            status,
            domain,
            duration,
            priceRenew,
            type: "backorder-register",
          })
        );
        const domainBackorder = backorder.filter(
          (domain) => domain.type === "backorder-register"
        );
        dispatch(backorderStatus("idle"));
        if (domainBackorder.length > 0) {
          notifyError("Tidak dapat memesan 2 atau lebih domain backorder");
        } else {
          notifySuccess("Domain anda telah ditambahkan ke keranjang");
        }
      }
    }
  }, [dispatch, result, backorder]);

  return (
    <MainLayouts summary={false}>
      <Card className="rounded-4 border-0 shadow-sm mb-4">
        <Card.Body>
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold text-qw-primary mb-0">
                  Domain Backorder
                </h5>
              </div>
              
              <div className="form-check py-3 px-4 mb-3" style={{ 
                border: '2px solid #e0e6ed',
                borderRadius: '8px',
                backgroundColor: '#f8f9fa'
              }}>
                <div className="d-flex align-items-start ps-2">
                  <input
                    type="radio"
                    className="form-check-input me-3"
                    name="domainBackorder"
                    id="domainBackorder"
                    value="domainBackorder"
                    defaultChecked={true}
                    style={{ marginTop: '2px' }}
                  />
                  <div className="flex-grow-1">
                    <label
                      htmlFor="domainBackorder"
                      className="form-check-label fw-bold d-block"
                    >
                      Domain Backorder
                    </label>
                    <p className="mb-0 mt-2 text-muted">
                      Peroleh domain terbaik yang ingin Anda miliki saat domain tersebut tersedia untuk pendaftaran
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="row mt-3">
                <div className="col-12">
                  <Form.Control
                    type="text"
                    placeholder="Nama Domain Backorder"
                    onChange={(e) => setDomain(e.target.value)}
                    value={domain}
                    style={{ 
                      border: '2px solid #e0e6ed',
                      borderRadius: '8px',
                      padding: '10px 16px'
                    }}
                  />
                </div>
              </div>
              
              {result.backorder_status === false && (
                <Alert variant="danger" className="mt-3">
                  <strong>Domain tidak tersedia</strong><br/>
                  {domain} tidak tersedia untuk backorder
                </Alert>
              )}
              
              <div className="d-flex justify-content-end mt-4 pb-3">
                {result.status === "loading" ? (
                  <button
                    className="btn btn-primary px-4 py-2"
                    onClick={handlerSendToCart}
                    disabled={true}
                    style={{ 
                      borderRadius: '8px',
                      padding: '10px 16px'
                    }}
                  >
                    <Spinner
                      animation="border"
                      style={{ marginRight: "12px" }}
                      size="sm"
                    />
                    Please wait...
                  </button>
                ) : (
                  <button
                    className="btn btn-primary px-4 py-2 add-to-cart"
                    onClick={handlerSendToCart}
                    style={{ 
                      borderRadius: '8px',
                      padding: '10px 16px'
                    }}
                  >
                    Tambahkan ke Keranjang
                  </button>
                )}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </MainLayouts>
  );
};

export default DomainBackorder;
